import React, { useState } from "react";
import { motion } from "framer-motion";
import TypingSection from "./TypingSection";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { Button } from "../ui/Button";
import { useNavigate } from "react-router-dom";
import imageFreelance from "../assets/img/img/freelance_client.jpg";

export default function App() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <header className="fixed top-0 z-50 w-full bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 h-20 flex items-center justify-between">
          <Link to="/">
            <div className="w-24  h-24 overflow-hidden">
              {" "}
              {/* Conteneur avec taille fixe */}
              <motion.img
                key={logo}
                src={logo}
                className="w-full h-full object-contain"
                animate={{ rotate: 360 }} // Applique la rotation de 360°
                transition={{ duration: 2, ease: "easeOut" }} // Durée de l'animation
              />
            </div>
          </Link>
          <nav className="hidden md:flex gap-6 items-center"></nav>
          <div className="flex items-center gap-3">
            <Link to="/login">
              <button className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 bg-transparent text-primary">
                Connexion
              </button>
            </Link>
            <Link to="/contact">
              <button className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
                Inscription
              </button>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-grow">
        <section className="relative bg-gradient-to-r from-blue-50 to-indigo-50 pt-24 pb-16 md:pt-32 md:pb-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-12">
              <div className="w-full md:Fw-1/2 space-y-6">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                  Gérez vos <span className="text-blue-600">recrutement</span>{" "}
                  clients et factures avec aisance
                </h1>
                <p className="text-lg text-gray-700 max-w-xl">
                  J'M Intérim freelance est la solution tout-en-un conçue pour
                  les recruteurs indépendants souhaitant optimiser leur workflow
                  et maximiser leur productivité.
                </p>
                <div className="flex items-center">
                  <Link to="/contact">
                    <Button
                      size="lg"
                      className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                      Je m'inscris
                    </Button>
                  </Link>
                </div>
              </div>

              <div className="w-full md:w-2/3 relative">
                <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl">
                  <img
                    src={imageFreelance}
                    className="w-full h-auto object-cover"
                  />
                </div>
                <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-blue-100 rounded-full opacity-50 -z-10"></div>
                <div className="absolute -top-6 -left-6 w-48 h-48 bg-indigo-100 rounded-full opacity-50 -z-10"></div>
              </div>
            </div>
          </div>

          <div
            className="absolute bottom-0 left-0 right-0 h-20 bg-white"
            style={{ clipPath: "polygon(0 100%, 100% 100%, 100% 0)" }}
          ></div>
        </section>

        {/* Key Features Section */}
        <section className="py-20 md:py-32 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16 md:mb-20">
              <h2 className="text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl md:text-5xl mb-4">
                Des fonctionnalités pensées pour vous
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-muted-foreground sm:text-xl">
                Simplifiez chaque aspect de votre activité de recruteur
                freelance grâce à des outils puissants et intuitifs.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
              {/* Feature 1 */}
              <div className="bg-card p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col items-center text-center">
                {/* Icon Placeholder - Consider adding an SVG icon component later */}
                <div className="p-3 rounded-full bg-primary/10 mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <h4 className="text-xl font-semibold text-card-foreground mb-3">
                  Suivi des recrutements
                </h4>
                <p className="text-muted-foreground text-sm text-justify">
                  Organisez et suivez chaque étape de votre processus de
                  recrutement, de la candidature à l'embauche, avec une
                  visibilité claire.
                </p>
              </div>
              {/* Feature 2 */}
              <div className="bg-card p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col items-center text-center">
                <div className="p-3 rounded-full bg-primary/10 mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <h4 className="text-xl font-semibold text-card-foreground mb-3">
                  Gestion des clients
                </h4>
                <p className="text-muted-foreground text-sm text-justify">
                  Centralisez les informations de vos clients et gérez vos
                  relations commerciales efficacement pour des partenariats
                  durables.
                </p>
              </div>
              {/* Feature 3 */}
              <div className="bg-card p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col items-center text-center">
                <div className="p-3 rounded-full bg-primary/10 mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                  </svg>
                </div>
                <h4 className="text-xl font-semibold text-card-foreground mb-3">
                  Génération de factures
                </h4>
                <p className="text-muted-foreground text-sm text-justify">
                  Créez et envoyez des factures professionnelles en quelques
                  clics pour un paiement rapide et une gestion financière
                  simplifiée.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <TypingSection></TypingSection>
      <footer className="bg-gray-900 text-white pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
            <div>
              <div className="flex items-center mb-6">
                <span className="text-2xl font-bold text-blue-400">J'❤️ </span>
                <span className="text-2xl font-bold ml-1 text-white">
                  INTÉRIM
                </span>
              </div>
              <p className="text-gray-400 mb-6">
                Votre partenaire de confiance pour le recrutement temporaire et
                permanent depuis plus de 17 ans.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/jm.interim"
                  className="text-gray-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="32"
                    height="32"
                  >
                    <circle cx="16" cy="16" r="16" fill="#1877F2" />
                    <path
                      fill="#FFF"
                      d="M22 11h-3c-.6 0-1 .4-1 1v2h4l-.5 4h-3.5v9h-4v-9H11v-4h3v-2.5C14 8.6 15.1 7 17.5 7H22v4z"
                    />
                  </svg>
                </a>

                <a
                  href="https://www.instagram.com/jm_interim/#"
                  className="text-gray-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="32"
                    height="32"
                  >
                    <linearGradient
                      id="insta-gradient"
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="1"
                    >
                      <stop offset="0%" stop-color="#f58529" />
                      <stop offset="50%" stop-color="#dd2a7b" />
                      <stop offset="100%" stop-color="#515bd4" />
                    </linearGradient>
                    <rect
                      width="512"
                      height="512"
                      rx="15%"
                      fill="url(#insta-gradient)"
                    />
                    <path
                      d="M256 164.1c-50.7 0-91.9 41.2-91.9 91.9S205.3 348 256 348s91.9-41.2 91.9-91.9S306.7 164.1 256 164.1zm0 151.7c-33 0-59.8-26.8-59.8-59.8s26.8-59.8 59.8-59.8 59.8 26.8 59.8 59.8-26.8 59.8-59.8 59.8zm116.4-152.6c0 11.8-9.6 21.3-21.3 21.3s-21.3-9.6-21.3-21.3 9.6-21.3 21.3-21.3 21.3 9.5 21.3 21.3z"
                      fill="#fff"
                    />
                    <path
                      d="M370.5 144h-229C111 144 96 159 96 181.5v149c0 22.5 15 37.5 37.5 37.5h229c22.5 0 37.5-15 37.5-37.5v-149c0-22.5-15-37.5-37.5-37.5zm-114.5 226.8c-63 0-114.3-51.2-114.3-114.3S193 142.3 256 142.3 370.3 193.6 370.3 256.5 319 370.8 256 370.8zm116.4-152.6c-11.8 0-21.3-9.6-21.3-21.3s9.6-21.3 21.3-21.3 21.3 9.6 21.3 21.3-9.6 21.3-21.3 21.3z"
                      fill="#fff"
                    />
                  </svg>
                </a>
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B33756107886&text&type=phone_number&app_absent=0"
                  className="text-gray-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="32"
                    height="32"
                  >
                    <path
                      fill="#25D366"
                      d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.688.883 5.17 2.376 7.188L4 29l7.004-2.288A11.948 11.948 0 0016.001 27c6.628 0 12.001-5.373 12.001-11.999C28.002 8.373 22.629 3 16.001 3z"
                    />
                    <path
                      fill="#fff"
                      d="M22.093 19.182c-.356-.178-2.103-1.038-2.427-1.156-.326-.119-.564-.178-.802.178-.237.356-.919 1.156-1.127 1.393-.208.237-.416.267-.772.089-.356-.178-1.504-.553-2.864-1.765-1.058-.945-1.771-2.108-1.98-2.464-.208-.356-.022-.547.157-.724.161-.16.356-.415.534-.623.178-.208.237-.356.356-.594.119-.237.06-.445-.03-.624-.089-.178-.802-1.931-1.099-2.639-.29-.696-.583-.601-.802-.612l-.683-.012c-.237 0-.623.089-.949.445-.326.356-1.246 1.215-1.246 2.962 0 1.748 1.276 3.445 1.454 3.682.178.237 2.513 3.833 6.157 5.187.86.296 1.533.473 2.057.604.864.273 1.65.235 2.273.143.694-.103 2.103-.859 2.401-1.688.296-.83.296-1.539.208-1.688-.089-.148-.326-.237-.683-.415z"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6">Nos agences</h3>

              <ul className="space-y-4">
                <li className="text-gray-400">
                  J'm intérim Asnières sur Seine (92)
                </li>
                <li className="text-gray-400">
                  J'm Capeneo Santé Toulouse (31)
                </li>
                <li className="text-gray-400">J'm Capeneo Brive (19)</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6">Siège</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=J'M+Intérim+4+avenue+Laurent+Cely+hall+A+92600+Asnières-sur-Seine"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:underline"
                  >
                    4 avenue Laurent Cely, hall A, 92600 Asnières-sur-Seine
                  </a>
                </li>

                <li className="flex items-start">
                  <a href="tel:0180882135" className="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                    <span className="text-gray-400">01 80 88 21 35</span>
                  </a>
                </li>

                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href="mailto:contact@jm-interim.com"
                    className="text-gray-400"
                  >
                    contact@jm-interim.com
                  </a>
                </li>

                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-gray-400">
                    Lundi - Vendredi: 8h - 18h
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm mb-4 md:mb-0">
                &copy; {new Date().getFullYear()} J'M INTÉRIM. Tous droits
                réservés.
              </p>
              <div className="flex space-x-6">
                <Link
                  to="/politique"
                  className="text-gray-400 hover:text-white text-sm"
                >
                  Politique de confidentialité/RGPD
                </Link>
                <Link
                  to="/mentions"
                  className="text-gray-400 hover:text-white text-sm"
                >
                  Mentions légales
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
